<template>
  <div class="empty-tasklist">
    <EmptyTasklistIllu class="illu" />
    <div class="text">
      <slot name="text">
        <p>{{ text }}</p>
      </slot>
      <div class="action-bg">
        <slot name="action" />
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";

import EmptyTasklistIllu from "@/components/illu/EmptyTasklistIllu.vue";

export default defineComponent({
  components: { EmptyTasklistIllu },
  props: {
    text: { type: String, required: false },
  },
});
</script>
<style scoped lang="scss">
.empty-tasklist {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 32px;
  justify-content: center;
  align-items: center;
  margin-bottom: 64px;
  overflow-x: hidden;
  svg.illu {
    width: calc(100% + 140px);
    height: auto;
  }
  .text {
    display: flex;
    flex-direction: column;
    row-gap: 16px;
    align-items: center;
    p {
      margin: 0;
      @extend %font-body-regular;
      @include themed() {
        color: t($grey-50);
      }
    }
    .action-bg {
      height: 32px;
    }
  }
}
</style>
